export default __webpack_public_path__ + "static/media/w01.6d433ffd.svg";